module.exports = __webpack_public_path__ + "img/百姓巡常行主k1.8.ca1308ef.png";